import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import InputPostal from '../form/inputs/InputPostal';
import Button from '../buttons/Button';
import Select from '../form/selects/Select';
import "moment/locale/pl";
import Moment from 'moment';
import banks from './../../static-data/banks.json';
import scrollPage from '../../services/scrollToErrors';
import Checkbox from '../form/checkbox/Checkbox';
import ButtonsNav from './../buttons-nav/ButtonsNav';

// const materialTheme = createMuiTheme({
//     overrides: {
//         MuiPickersCalendarHeader: {
//             switchHeader: {
//                 color: '#74726b',
//             },
//           },
//       MuiPickersDay: {
//             day: {
//                 color: '#74726b',
//             },
//         },
//     }
//   });

const CompanyDetails = ( props ) => {
    let [ load, setLoad ]                           = useState(false);
    let [ isOpen, setIsOpen ]                       = useState(false);
    let [ forceValidateNip, setForceValidateNip ]   = useState(false);
    let [ forceValidate, setForceValidate ]         = useState(false);
    let [ companyStartPicker, setCompanyStartPicker ] = useState(false);
    let [ dataFromGUS, setDataFromGUS ] = useState(false);

    const dispatch      = useDispatch()
    let nip             = useSelector(state => state.nip)
    let companyName     = useSelector(state => state.companyName)
    let companyAddress  = useSelector(state => state.companyAddress)
    let postalCustomer  = useSelector(state => state.postalCustomer)
    let city            = useSelector(state => state.city)
    let additionalCompanyAddress  = useSelector(state => state.additionalCompanyAddress)
    let additionalPostalCustomer  = useSelector(state => state.additionalPostalCustomer)
    let additionalCity            = useSelector(state => state.additionalCity)
    let phone           = useSelector(state => state.phone)
    let email           = useSelector(state => state.email)
    let emailFV         = useSelector(state => state.emailFV)
    let employeesNumber = useSelector(state => state.employeesNumber)
    let website         = useSelector(state => state.website)
    let additionalAddress       = useSelector(state => state.additionalAddress)
    let bank       = useSelector(state => state.bank)
    let bankAccountsNumbers     = useSelector(state => state.bankAccountsNumbers)
    let bankAccount             = useSelector(state => state.bankAccount)
    let otherBankAccountCheckbox = useSelector(state => state.otherBankAccountCheckbox)
    let otherBankAccount        = useSelector(state => state.otherBankAccount)
    let consentAutomaticBankAccountCheckbox = useSelector(state => state.consentAutomaticBankAccountCheckbox);
    let legalRepresentative             = useSelector(state => state.legalRepresentative);

    
    
    let validateNIP = async () => {
        await setForceValidateNip(true);
        await wait(100);

        let result;
        let elements = document.querySelectorAll('.error-item-nip');
        if( elements.length > 0 ) {
            result = false;
            await setForceValidateNip(false);
        } else {
            result = true;
        }
        return result;
    }

    let getDataFromGUS = async (type) => {
        let validateNip = await validateNIP();
        await wait(100);
        if ( validateNip ) {
            let req = new XMLHttpRequest();
            req.open('GET', `https://newonline.leasingoptymalny.pl/API/nip2.php?id=5c3fe4b4fce445d481e92a660953&nip=${nip}`);
            req.send();

            req.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    let data = JSON.parse(req.response);
                    if(data && data.dane && data.dane.ErrorCode !== "4") {
                        if(!type) {
                            dispatch({ type: 'COMPANY_NAME_CHANGE', value: data.dane.Nazwa })
                            dispatch({ type: 'COMPANY_ADDRESS_CHANGE', value: data.dane.Ulica + ' ' + data.dane.NrNieruchomosci })
                            dispatch({ type: 'COMPANY_START_CHANGE', value: data.dane.dataRozpoczeciaDzialalnosci })

                            dispatch({ type: 'POSTAL_CUSTOMER_CHANGE', value: data.dane.KodPocztowy })
                            dispatch({ type: 'CITY_CHANGE', value: data.dane.Miejscowosc })
                            dispatch({ type: 'GUS_DATA_CHANGE', value: data.dane })
                            dispatch({ type: 'REGISTRY_TYPE_CHANGE', value: data.dane.Krs && data.dane.Krs.length > 0  ? 'KRS' : 'CEIDG' })
                            dispatch({ type: 'ID_NUMBER_CHANGE', value: data.dane.Krs && data.dane.Krs.length > 0 ? data.dane.Krs : '' })
                            dispatch({ type: 'PROFESSION_CHANGE', value: data.dane.pkdKod  })
                        }else if(type == "register_type") {
                            dispatch({ type: 'GUS_DATA_CHANGE', value: data.dane })
                            dispatch({ type: 'REGISTRY_TYPE_CHANGE', value: data.dane.Krs && data.dane.Krs.length > 0  ? 'KRS' : 'CEIDG' })
                            dispatch({ type: 'ID_NUMBER_CHANGE', value: data.dane.Krs && data.dane.Krs.length > 0 ? data.dane.Krs : '' })
                            dispatch({ type: 'COMPANY_START_CHANGE', value: data.dane.dataRozpoczeciaDzialalnosci })
                            dispatch({ type: 'PROFESSION_CHANGE', value: data.dane.pkdKod  })
                        }
                        getAccountNumbers();
                        setDataFromGUS(true);
                    }
                }
            });
        }
    }

    let getAccountNumbers = () => {
        let date = Moment(new Date()).format("YYYY-MM-DD")
        let req = new XMLHttpRequest();
            req.open('GET', `https://wl-api.mf.gov.pl/api/search/nip/${nip}?date=${date}`);
            req.setRequestHeader("accept", "application/json"); 
            req.send();

            req.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    let data = JSON.parse(req.response);
                    if(data && data.result && data.result.subject && data.result.subject.accountNumbers) {
                        let accountsNumbersArr = [];
                        for(let i = 0; i<data.result.subject.accountNumbers.length; i++) {
                            let item = data.result.subject.accountNumbers[i];
                            accountsNumbersArr = [...accountsNumbersArr, {
                                name: item,
                                val: item,
                                key: i
                            }]
                        }
                        dispatch({ type: 'BANK_ACCOUNTS_NUMBERS_CHANGE', value: accountsNumbersArr })
                    }else{
                        dispatch({ type: 'BANK_ACCOUNTS_NUMBERS_CHANGE', value: [] })
                        dispatch({ type: 'OTHER_BANK_ACCOUNT_CHECKBOX_CHANGE', value: true })
                    }
                }
            });
    }


    const getBankUrlRedirect = ( key ) => {
        if ( key.length == 0 ) {
            return false;
        }
        let getItem = banks.findIndex(x => x.name === key);

        let req = new XMLHttpRequest();
            req.open('GET', `https://newonline.leasingoptymalny.pl/API/linkVeryf.php?id=5c3fe4b4fce445d481e92a660953&bank=${ banks[getItem].key }`);
            req.send();

            req.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    let data = JSON.parse(req.response);
                    if(data && data.redirect_uri) {
                        dispatch({ type: 'BANK_URI_CHANGE', value: data.redirect_uri })
                    }
                }
            });
        
    }
    async function wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
    }
    
    let prev = () => {
        props.prev();
    }
    let next = async() => {
        await setForceValidate(true);
        await wait(500);
        let scroll = await scrollPage();
        if ( scroll ) {
            await setForceValidate(true);
        } else {
            await setForceValidate(false);
            await props.next();
        }
    }

    let changeAdditionalAddress = ( val ) => {
        dispatch({ type: 'ADDITIONAL_ADDRESS_CHANGE', value: val })

        if ( !val ) {
            dispatch({ type: 'ADDITIONAL_COMPANY_ADDRESS_CHANGE', value: '' })
            dispatch({ type: 'ADDITIONAL_POSTAL_CUSTOMER_CHANGE', value: '' })
            dispatch({ type: 'ADDITIONAL_CITY_CHANGE', value: '' })
        }
    }

    const getDataAndNext = async() => {
        if(nip && !dataFromGUS) {
            await getDataFromGUS("register_type");
            await wait(500);
        }
        await next();
    }

    return (
        <div className="customer-information">
            <div className="container">
                <Heading title="Company details" borderBottom />
                <div className="input-row">
                    <div className="col">
                        <Input  name="full-name-company"
                            id="full-name-company"
                            required={ true }
                            setFunction={ val => dispatch({ type: 'COMPANY_NAME_CHANGE', value: val }) }
                            type="text"
                            label="Company Name"
                            placeholder={ "Full name of the company" }
                            val={ companyName }
                            size="full" 
                            regExp={/.*/}
                            allowChars={/.*/}
                            minChar={ 1 } 
                            forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="legal-representative"
                            id="legal-representative"
                            required={ true }
                            setFunction={ val => dispatch({ type: 'LEGAL_REPRESENTATIVE_CHANGE', value: val }) }
                            type="text"
                            label="Legal representative"
                            placeholder={ "Legal representative of company" }
                            val={ legalRepresentative }
                            size="full" 
                            regExp={/.*/}
                            allowChars={/.*/}
                            minChar={ 1 } 
                            forceValidate={ forceValidate } />
                    </div>
                </div>

                <Heading title="Full address of the registered Company" 
                    medium 
                    borderBottomDotted 
                    tip={ false } 
                    tipHeader="Liczba pracowników"
                    tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />
                <div className="input-row">
                    <div className="col">
                        <Input  name="city"
                                id="city"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'CITY_CHANGE', value: val }) }
                                type="text"
                                label={ "City / Place" }
                                placeholder={ "City / Place" }
                                val={ city }
                                size="full" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="address-company"
                                id="address-company"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'COMPANY_ADDRESS_CHANGE', value: val }) }
                                type="text"
                                label={ "Street and number" }
                                placeholder={ "Street and number" }
                                val={ companyAddress }
                                size="full" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                </div>

                <div className="input-row">
                    <div className="col">
                        <Checkbox   required={ false } 
                                    id="additionalAddress"
                                    setFunction={ (val) => changeAdditionalAddress(val) }
                                    val={ additionalAddress }
                                    forceValidate={ forceValidate }
                                    text="Add a correspondence address (indicate if the address is different from the one above)." />
                    </div>
                </div>
                { additionalAddress &&
                    <div className="input-row">
                        <div className="col">
                            <Input  name="additional-city"
                                    id="additional-city"
                                    required={ true }
                                    setFunction={ val => dispatch({ type: 'ADDITIONAL_CITY_CHANGE', value: val }) }
                                    type="text"
                                    label={ "City / Place" }
                                    placeholder={ "City / Place" }
                                    val={ additionalCity }
                                    size="full" 
                                    regExp={/.*/}
                                    allowChars={/.*/}
                                    minChar={ 1 } 
                                    forceValidate={ forceValidate } />
                        </div>
                        <div className="col">
                            <Input  name="additional-address-company"
                                    id="additional-address-company"
                                    required={ true }
                                    setFunction={ val => dispatch({ type: 'ADDITIONAL_COMPANY_ADDRESS_CHANGE', value: val }) }
                                    type="text"
                                    label={ "Street and number" }
                                    placeholder={ "Street and number" }
                                    val={ additionalCompanyAddress }
                                    size="full" 
                                    regExp={/.*/}
                                    allowChars={/.*/}
                                    minChar={ 1 } 
                                    forceValidate={ forceValidate } />
                        </div>
                    </div>
                }

                <Heading title="Contact details" 
                    medium 
                    borderBottomDotted 
                    tip={ false } 
                    tipHeader="Liczba pracowników"
                    tipText="Wpisz łączną liczbę pracowników, niezależnie od formy zatrudnienia. W przypadku działalności jednoosobowej bez osób zatrudnionych, wpisz 0." />

                <div className="input-row">
                    <div className="col">
                        <Input  name="phone"
                                id="phone"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'PHONE_CHANGE', value: val }) }
                                type="text"
                                label={ "Contact no." }
                                placeholder={ "Contact no." }
                                val={ phone }
                                size="full" 
                                regExp={/^[+0-9]{9,13}$/}
                                allowChars={/^[+0-9]{0,13}$/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                    <div className="col">
                        <Input  name="email"
                                id="email"
                                required={ true }
                                setFunction={ val => dispatch({ type: 'EMAIL_CHANGE', value: val }) }
                                type="text"
                                label={ "E-mail address" }
                                placeholder={ "E-mail address" }
                                val={ email }
                                size="full" 
                                regExp={/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/}
                                allowChars={/.*/}
                                minChar={ 1 } 
                                forceValidate={ forceValidate } />
                    </div>
                </div>  

                <div className="input-row">
                    <div className="col">
                        <Input  name="website"
                                id="website"
                                required={ false }
                                setFunction={ val => dispatch({ type: 'WEBSITE_CHANGE', value: val }) }
                                type="text"
                                label={ "www site" }
                                placeholder={ "www site" }
                                val={ website }
                                size="full" 
                                regExp={/.*/}
                                allowChars={/.*/}
                                minChar={ 0 } 
                                forceValidate={ forceValidate } />
                    </div>
                </div>
                
                <ButtonsNav prev={() => prev()} next={() => getDataAndNext()} />
            </div>
        </div>
    )
}

export default CompanyDetails;